module.exports = __webpack_public_path__ + "img/76ne.ea264865.svg";